import React from "react";
import { motion } from "framer-motion";
import { FaArrowRight, FaGithub, FaLinkedin } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi2";
import avatar from "../assets/nexoicon.png";
import "./Hero.css";

const fadeUp = {
  hidden:  { opacity: 0, y: 24 },
  show: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
  }),
};

const tags = ["React", "Next.js", "Python", "Node.js", "Automatización", "Web Scraping"];

function Hero() {
  return (
    <section className="hero">
      {/* Mesh gradient background */}
      <div className="hero-mesh" aria-hidden="true">
        <div className="hero-mesh__orb hero-mesh__orb--1" />
        <div className="hero-mesh__orb hero-mesh__orb--2" />
        <div className="hero-mesh__orb hero-mesh__orb--3" />
      </div>

      <div className="hero-inner container">
        {/* Avatar column */}
        <motion.div
          className="hero-avatar-col"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero-avatar-ring">
            <img src={avatar} alt="NexoCode" className="hero-avatar" />
            <span className="hero-avatar-status" title="Disponible" />
          </div>

          {/* Social pills */}
          <div className="hero-socials">
            <a href="https://github.com/Eduardo-ui-stack/NexoCode" target="_blank" rel="noreferrer" className="hero-social-btn">
              <FaGithub /> GitHub
            </a>
            <a href="https://www.linkedin.com/in/nexocode-company-0504202b4/" target="_blank" rel="noreferrer" className="hero-social-btn">
              <FaLinkedin /> LinkedIn
            </a>
          </div>
        </motion.div>

        {/* Info column */}
        <div className="hero-info">
          {/* Badge disponibilidad */}
          <motion.span
            className="hero-badge"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.1}
          >
            <span className="hero-badge__dot" />
            Disponible para proyectos
            <HiSparkles className="hero-badge__icon" />
          </motion.span>

          {/* Heading */}
          <motion.h1
            className="hero-heading"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.2}
          >
            NexoCode<span className="hero-heading__accent">.</span>
            <br />
            <span className="hero-heading__thin">Mobile &amp; Web</span>
            <br />
            <span className="hero-heading__gradient">Developer</span>
          </motion.h1>

          {/* Description */}
          <motion.p
            className="hero-description"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.35}
          >
            Construyo aplicaciones web y móviles modernas enfocadas en rendimiento,
            escalabilidad y buenas prácticas. Ayudo a negocios y creadores a convertir
            ideas en productos digitales de alto impacto.
          </motion.p>

          {/* Tags */}
          <motion.div
            className="hero-tags"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.45}
          >
            {tags.map((tag) => (
              <span key={tag} className="hero-tag">{tag}</span>
            ))}
          </motion.div>

          {/* CTAs */}
          <motion.div
            className="hero-actions"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.55}
          >
            <a href="/projects" className="btn-primary">
              Ver proyectos <FaArrowRight className="btn-icon" />
            </a>
            <a href="/servicios" className="btn-secondary">
              Mis servicios
            </a>
          </motion.div>

          {/* Stats row */}
          <motion.div
            className="hero-stats"
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0.65}
          >
            <div className="hero-stat">
              <span className="hero-stat__number">10+</span>
              <span className="hero-stat__label">Proyectos</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="hero-stat__number">3+</span>
              <span className="hero-stat__label">Años exp.</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="hero-stat__number">100%</span>
              <span className="hero-stat__label">Satisfacción</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
